import moment from 'moment'
import {useMemo} from "react";
import {getLocale, useIntl} from "umi";

interface Props {
  formatMessage?: any
}

const useConstants = (props?: Props) => {
  const {
    formatMessage
  } = props ?? {}
  const locale = getLocale()

  const SUBSCRIBE_SETTING_PAGE_REG = /\/subscribe\/subscribeSetting\?{0,1}.*/g

  const SUBMIT_TYPE = {
    SUBMIT: 'submit',
    PREVIEW: 'preview',
    TEST: 'test',
    CANCEL: 'cancel'
  }

  const OPTIONS_WEEK = [
    { value: '1', text: formatMessage?.({id: 'common_mon'}) },
    { value: '2', text: formatMessage?.({id: 'common_tues'}) },
    { value: '3', text: formatMessage?.({id: 'common_wed'}) },
    { value: '4', text: formatMessage?.({id: 'common_thur'}) },
    { value: '5', text: formatMessage?.({id: 'common_fri'}) },
    { value: '6', text: formatMessage?.({id: 'common_sat'}) },
    { value: '7', text: formatMessage?.({id: 'common_sun'}) },
  ]

  const OPTIONS_DATE = [
    { value: '1', text: `1${locale === 'en-US' ? '' : '号'}` },
    { value: '2', text: `2${locale === 'en-US' ? '' : '号'}` },
    { value: '3', text: `3${locale === 'en-US' ? '' : '号'}` },
    { value: '4', text: `4${locale === 'en-US' ? '' : '号'}` },
    { value: '5', text: `5${locale === 'en-US' ? '' : '号'}` },
    { value: '6', text: `6${locale === 'en-US' ? '' : '号'}` },
    { value: '7', text: `7${locale === 'en-US' ? '' : '号'}` },
    { value: '8', text: `8${locale === 'en-US' ? '' : '号'}` },
    { value: '9', text: `9${locale === 'en-US' ? '' : '号'}` },
    { value: '10', text: `10${locale === 'en-US' ? '' : '号'}` },
    { value: '11', text: `11${locale === 'en-US' ? '' : '号'}` },
    { value: '12', text: `12${locale === 'en-US' ? '' : '号'}` },
    { value: '13', text: `13${locale === 'en-US' ? '' : '号'}` },
    { value: '14', text: `14${locale === 'en-US' ? '' : '号'}` },
    { value: '15', text: `15${locale === 'en-US' ? '' : '号'}` },
    { value: '16', text: `16${locale === 'en-US' ? '' : '号'}` },
    { value: '17', text: `17${locale === 'en-US' ? '' : '号'}` },
    { value: '18', text: `18${locale === 'en-US' ? '' : '号'}` },
    { value: '19', text: `19${locale === 'en-US' ? '' : '号'}` },
    { value: '20', text: `20${locale === 'en-US' ? '' : '号'}` },
    { value: '21', text: `21${locale === 'en-US' ? '' : '号'}` },
    { value: '22', text: `22${locale === 'en-US' ? '' : '号'}` },
    { value: '23', text: `23${locale === 'en-US' ? '' : '号'}` },
    { value: '24', text: `24${locale === 'en-US' ? '' : '号'}` },
    { value: '25', text: `25${locale === 'en-US' ? '' : '号'}` },
    { value: '26', text: `26${locale === 'en-US' ? '' : '号'}` },
    { value: '27', text: `27${locale === 'en-US' ? '' : '号'}` },
    { value: '28', text: `28${locale === 'en-US' ? '' : '号'}` },
    { value: '29', text: `29${locale === 'en-US' ? '' : '号'}` },
    { value: '30', text: `30${locale === 'en-US' ? '' : '号'}` },
    { value: '31', text: `31${locale === 'en-US' ? '' : '号'}` },
  ]

  const OPTIONS_TIME = [
    { value: '0', text: '00:00' },
    { value: '1', text: '01:00' },
    { value: '2', text: '02:00' },
    { value: '3', text: '03:00' },
    { value: '4', text: '04:00' },
    { value: '5', text: '05:00' },
    { value: '6', text: '06:00' },
    { value: '7', text: '07:00' },
    { value: '8', text: '08:00' },
    { value: '9', text: '09:00' },
    { value: '10', text: '10:00' },
    { value: '11', text: '11:00' },
    { value: '12', text: '12:00' },
    { value: '13', text: '13:00' },
    { value: '14', text: '14:00' },
    { value: '15', text: '15:00' },
    { value: '16', text: '16:00' },
    { value: '17', text: '17:00' },
    { value: '18', text: '18:00' },
    { value: '19', text: '19:00' },
    { value: '20', text: '20:00' },
    { value: '21', text: '21:00' },
    { value: '22', text: '22:00' },
    { value: '23', text: '23:00' },
  ]

  const SETTING_FIELDS = {
    RECEIVERS: 'receivers',
    TITLE: 'title',
    CONTENT: 'content',
    WAYS: 'ways',
    FREQUENCY: 'frequency',
    CYCLE: 'cycle',
    SENDOUTEMAIL:'sendOutEmail',
    VIEWPORT_WIDTH: 'viewport_width'
  }

  const FREQUENCY_TYPE = {
    NOW: '1',
    ONE: '2',
    HOUR: '3',
    DAY: '4',
    WEEK: '5',
    MONTH: '6',
  }

  const WAYS = [
    {
      name: formatMessage?.({id: 'subscribe_setting_input_label_ways_email'}),
      value: '1'
    },
    {
      name: formatMessage?.({id: 'subscribe_setting_input_label_ways_wechat'}),
      value: '2'
    },
  ]

  const SENDOUTEMAILRADIO = [
    {
      name: formatMessage?.({ id: 'common_yes' }),
      value: 'send'
    },
    {
      name: formatMessage?.({ id: 'common_no' }),
      value: 'no'
    },
  ]

  const OPTIONS_FREQUENCY = [
    { value: FREQUENCY_TYPE.NOW, text: formatMessage?.({id: 'subscribe_setting_input_label_now'}) },
    { value: FREQUENCY_TYPE.ONE, text: formatMessage?.({id: 'subscribe_setting_input_label_one'}) },
    { value: FREQUENCY_TYPE.HOUR, text: formatMessage?.({id: 'subscribe_setting_input_label_hour'}) },
    { value: FREQUENCY_TYPE.DAY, text: formatMessage?.({id: 'subscribe_setting_input_label_day'}) },
    { value: FREQUENCY_TYPE.WEEK, text: formatMessage?.({id: 'subscribe_setting_input_label_week'}) },
    { value: FREQUENCY_TYPE.MONTH, text: formatMessage?.({id: 'subscribe_setting_input_label_month'}) },
  ]

  const FREQUENCY_KEY_MAP = {
    [FREQUENCY_TYPE.ONE]: ['frequency_interval', 'frequency_time'],
    [FREQUENCY_TYPE.HOUR]: ['frequency_interval'],
    [FREQUENCY_TYPE.DAY]: ['frequency_time'],
    [FREQUENCY_TYPE.WEEK]: ['frequency_interval', 'frequency_time'],
    [FREQUENCY_TYPE.MONTH]: ['frequency_interval', 'frequency_time'],
  }

  const HOUR_FORMAT = 'HH:mm'
  const DATE_FORMAT = 'YYYY-MM-DD'
  const MONTH_FORMAT = 'YYYY-MM'

  const INITIAL_VALUES = {
    [SETTING_FIELDS.RECEIVERS]: [],
    [SETTING_FIELDS.TITLE]: '',
    [SETTING_FIELDS.CONTENT]: '',
    [SETTING_FIELDS.WAYS]: ['1'],
    [SETTING_FIELDS.SENDOUTEMAIL]: 'no',
    [SETTING_FIELDS.FREQUENCY]: {
      type: FREQUENCY_TYPE.NOW,
    },
    [SETTING_FIELDS.CYCLE]: [moment(), moment().add(1, 'month')],
    [SETTING_FIELDS.VIEWPORT_WIDTH]: '',
  }

  const DEFAULT_FREQUNCY_VALUE = {
    [FREQUENCY_TYPE.ONE]: {
      [FREQUENCY_KEY_MAP[FREQUENCY_TYPE.ONE][0]]: moment().format(DATE_FORMAT),
      [FREQUENCY_KEY_MAP[FREQUENCY_TYPE.ONE][1]]: moment().format(HOUR_FORMAT)
    },
    [FREQUENCY_TYPE.HOUR]: {
      [FREQUENCY_KEY_MAP[FREQUENCY_TYPE.HOUR][0]]: ['0']
    },
    [FREQUENCY_TYPE.DAY]: {
      [FREQUENCY_KEY_MAP[FREQUENCY_TYPE.DAY][0]]: moment().format(HOUR_FORMAT)
    },
    [FREQUENCY_TYPE.WEEK]: {
      [FREQUENCY_KEY_MAP[FREQUENCY_TYPE.WEEK][0]]: ['1'],
      [FREQUENCY_KEY_MAP[FREQUENCY_TYPE.WEEK][1]]: moment().format(HOUR_FORMAT)
    },
    [FREQUENCY_TYPE.MONTH]: {
      [FREQUENCY_KEY_MAP[FREQUENCY_TYPE.MONTH][0]]: ['1'],
      [FREQUENCY_KEY_MAP[FREQUENCY_TYPE.MONTH][1]]: moment().format(HOUR_FORMAT)
    },
  }

  const FIELD_STATUS: {
    [key: string]: 'success' | 'error' | 'validating'
  } = {
    VALIDATING: 'validating',
    SUCCESS: 'success',
    ERROR: 'error',
  }

  return {
    SUBMIT_TYPE,
    OPTIONS_WEEK,
    OPTIONS_DATE,
    OPTIONS_TIME,
    SETTING_FIELDS,
    FREQUENCY_TYPE,
    WAYS,
    SENDOUTEMAILRADIO,
    OPTIONS_FREQUENCY,
    FREQUENCY_KEY_MAP,
    HOUR_FORMAT,
    DATE_FORMAT,
    MONTH_FORMAT,
    SUBSCRIBE_SETTING_PAGE_REG,
    INITIAL_VALUES,
    DEFAULT_FREQUNCY_VALUE,
    FIELD_STATUS
  }
}

const year = moment().year();
const yearToDate = moment(`${year}-01-01`).format('YYYY-MM-DD')
const allOfTime = moment(`2017-01-01`).format('YYYY-MM-DD')
export const SIDER_SELECT = {
  Day: [
    {
      tabName: 'Yesterday',
      startDay: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      endDay: moment().subtract(1, 'day').format('YYYY-MM-DD')
    },
    {
      tabName: 'Last 7 Days',
      startDay: moment().subtract(7, 'day').format('YYYY-MM-DD'),
      endDay: moment().subtract(1, 'day').format('YYYY-MM-DD')
    },
    {
      tabName: 'Last 30 Days',
      startDay: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      endDay: moment().subtract(1, 'days').format('YYYY-MM-DD'),
    },
    {
      tabName: 'Last 90 Days',
      startDay: moment().subtract(90, 'days').format('YYYY-MM-DD'),
      endDay: moment().subtract(1, 'day').format('YYYY-MM-DD')
    },
    {
      tabName: 'Last 180 Days',
      startDay: moment().subtract(180, 'days').format('YYYY-MM-DD'),
      endDay: moment().subtract(1, 'day').format('YYYY-MM-DD')
    },
    {
      tabName: 'Last 365 Days',
      startDay: moment().subtract(365, 'days').format('YYYY-MM-DD'),
      endDay: moment().subtract(1, 'day').format('YYYY-MM-DD')
    },
    {
      tabName: 'Year to Date',
      startDay: yearToDate,
    },
    {
      tabName: 'All of Time',
      startDay: allOfTime,
    }
  ]
}

export const useSubscribeManagerTableMap = () => {
  const { formatMessage } = useIntl();
  return useMemo(() => {
    // 和设计国龙沟通后，推送中的状态用3的颜色
    const PUSH_RESULT:any = {
      0: {
        className: "table-text",
        text: formatMessage({id: "subscribe_manager_push_result_not"}),
      },
      1: {
        className: "table-text--success",
        text: formatMessage({id: "subscribe_manager_push_result_success"}),
      },
      2: {
        className: "table-text--fail",
        text: formatMessage({id: "subscribe_manager_push_result_fail"}),
      },
      3: {
        className: "table-text--partiallysuccess",
        text: formatMessage({id: "subscribe_manager_push_result_part_success"}),
      },
      4: {
        className: "table-text--partiallysuccess",
        text: formatMessage({id: "subscribe_manager_push_result_pushing"}),
      },
      5: {
        className: "table-text",
        text: formatMessage({id: "subscribe_manager_push_in_queue"}),
      },
    }
    const PUSH_METHOD:any = {
      0: formatMessage({id: "subscribe_manager_push_method_invalid"}),
      1: formatMessage({id: "subscribe_manager_push_method_email"}),
      2: formatMessage({id: "subscribe_manager_push_method_weixin"}),
    }
    const CURRENT_STATE:any = {
      // 和设计确认后，未订阅和已结束都用黑色
      0:{
        className: "table-text",
        text: formatMessage({id: "subscribe_manager_current_state_unsubscribed"}),
      },
      1: {
        className: "table-text--success",
        text: formatMessage({id: "subscribe_manager_current_state_subscribing"}),
      },
      2:{
        className: "table-text",
        text: formatMessage({id: "subscribe_manager_current_state_finished"}),
      },
      3:{
        className: "table-text--deleted",
        text: formatMessage({id: "subscribe_manager_current_state_failure"}),
      }
    }
    const SUBSCRIBE_REQUEST_OPTIONS:any = {
      // 退订
      "unsubscribe": {
        name: formatMessage({id: "subscribe_manager_handle_unsubscribe"}),
        params: {
          subscribe_status: 0
        }
      },
      // 再次发送
      "pushAgain": {
        name: formatMessage({id: "subscribe_manager_handle_push_again"}),
        params: {
          frequency_type: 8,
        }
      },
      // 重新订阅
      "resubscribe": {
        name: formatMessage({id: "subscribe_manager_handle_resubscribe"}),
        params: {
          subscribe_status: 1
        }
      },
      "delete":{
        name: formatMessage({id: "common_delete"}),
        params: {
          subscribe_status:3 
        }
      }
    }
    const WEEK_TEXT = {
      // 2.18版本不开发订阅管理页面的中英文功能
      // "1": "周一",
      // "2": "周二",
      // "3": "周三",
      // "4": "周四",
      // "5": "周五",
      // "6": "周六",
      // "7": "周日",

      // 开发中英文转换时再打开
      "1": formatMessage({id: "common_mon"}),
      "2": formatMessage({id: "common_tues"}),
      "3": formatMessage({id: "common_wed"}),
      "4": formatMessage({id: "common_thur"}),
      "5": formatMessage({id: "common_fri"}),
      "6": formatMessage({id: "common_sat"}),
      "7": formatMessage({id: "common_sun"}),
    }
    const TIME_TEXT = {
      '0': '00:00',
      '1': '01:00',
      '2': '02:00',
      '3': '03:00',
      '4': '04:00',
      '5': '05:00',
      '6': '06:00',
      '7': '07:00',
      '8': '08:00',
      '9': '09:00',
      '10': '10:00',
      '11': '11:00',
      '12': '12:00',
      '13': '13:00',
      '14': '14:00',
      '15': '15:00',
      '16': '16:00',
      '17': '17:00',
      '18': '18:00',
      '19': '19:00',
      '20': '20:00',
      '21': '21:00',
      '22': '22:00',
      '23': '23:00',
    };

    return {
      PUSH_RESULT,
      PUSH_METHOD,
      CURRENT_STATE,
      SUBSCRIBE_REQUEST_OPTIONS,
      WEEK_TEXT,
      TIME_TEXT,
    }
  }, [getLocale()])
}


export default useConstants
